module.exports = __webpack_public_path__ + "static/img/loading.e8a0fbc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = G/2H
// module chunks = 1